(function () {
  var bar = document.getElementById('MembershipStickyCta');
  if (!bar || !window.IntersectionObserver) return;

  var heroCta = document.querySelector('.membership-hero__cta');
  var finalCta = document.querySelector('[id^="shopify-section-"][id$="__membership_final"] .button');
  var heroVisible = true;
  var finalVisible = false;

  function sync() {
    bar.hidden = heroVisible || finalVisible;
  }

  if (heroCta) {
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      sync();
    }).observe(heroCta);
  } else {
    heroVisible = false;
    sync();
  }

  if (finalCta) {
    new IntersectionObserver(function (entries) {
      finalVisible = entries[0].isIntersecting;
      sync();
    }).observe(finalCta);
  }
})();
